module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/i3ej9y/tc-custom/9783965370326.jpg?1703128983040",
      "alt": "This image is the cover for the book Novice, Classics To Go"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Novice, Classics To Go\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("This is a classic science fiction short story by James H. Schmitz and illustrated by Schoenherr that first appeared in Analog Science Fact and Fiction. The following passage is part of its intriguing intro: 'A novice is one who is inexperienced—but that doesn't mean incompetent. Nor does it mean stupid!' (Rakuten Kobo)")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      James H. Schmitz\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("James Henry Schmitz (October 15, 1911 – April 18, 1981) was an American science fiction writer born in Hamburg, Germany of American parents. Schmitz wrote mostly short stories, which sold chiefly to Galaxy Science Fiction and Astounding Science-Fiction (which later became Analog Science Fiction and Fact). Gale Biography in Context called him \"a craftsman-like writer who was a steady contributor to science fiction magazines for over 20 years.\" (Wikipedia)")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0